import { CommandBarButton, IOverflowSetItemProps, OverflowSet } from '@fluentui/react';
import React,{ FC } from 'react';
import './OverflowMenu.scss';

const onRenderItemStyles = {
    root: { padding: '10px' },
    menuIcon: { fontSize: '16px', color:'green' },
};

const onRenderOverflowButtonStyles = {
    root: { padding: '10px' },
    menuIcon: { fontSize: '16px' },
};

export interface OverflowMenuProps{
    overflowItems?: IOverflowSetItemProps[];
}

export const OverflowMenu: FC<OverflowMenuProps> = (props: OverflowMenuProps) => {
    const {overflowItems} = props;
    const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
        return (
            <CommandBarButton
                role="menuitem"
                className={item.className}
                aria-label={item.name}
                styles={onRenderItemStyles}
                iconProps={item.iconProps}
                onClick={item.onClick}
            />
        );
    };
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onRenderOverflowButton = (items?: any[]): JSX.Element => {
        return (
            <CommandBarButton
                role="menuitem"
                title="More items"
                styles={onRenderOverflowButtonStyles}
                menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: items ?? [] }}
            />
        );
    };
    return (
        <OverflowSet
        className='overflowMenu'
        role='menubar'
        vertical
        overflowItems={overflowItems}

        onRenderOverflowButton={onRenderOverflowButton}
        onRenderItem={onRenderItem}
    />
    );
};
